import {toast} from "bulma-toast";
import {detect} from "detect-browser";
import * as React from "react";
import * as CopyToClipboard from "react-copy-to-clipboard";
import {FormattedMessage, injectIntl} from "react-intl";
import { InjectedIntlProps } from "react-intl";
import {connect} from "react-redux";
import translations from "./translations";

interface IProps extends InjectedIntlProps {
  user: string;
}

const Bugreport: React.SFC<IProps> = props => {
  let bugreport: string = "";

  const openInNewTab = (url: any) => {
    const win: any = window.open(url, "_blank");
    win.focus();
  };

  const getOS = () => {
    const browser = detect();
    if (browser !== null) {
      return browser.os;
    } else {
      return "unknown";
    }
  };

  const getName = () => {
    const browser = detect();
    if (browser !== null) {
      return browser.name;
    } else {
      return "unknown";
    }
  };

  const getVersion = () => {
    const browser = detect();
    if (browser !== null) {
      return browser.version;
    } else {
      return "unknown";
    }
  };

  const prepareBugReport = () => {
    bugreport = "BUG REPORT\n";
    bugreport += "\nUser:\t" + props.user.toLocaleUpperCase();
    bugreport += "\n\r\nTime\t\t" + String(Date());
    bugreport += "\nOS:\t\t" + getOS();
    bugreport += "\nBrowser:\t" + getName();
    bugreport += "\nVersion:\t" + getVersion();
    bugreport += "\n\nWhat has happened:\n";
    bugreport += "\n\nOn which site has the error occured:\n";
    return bugreport;
  };

//   const nl2br = (str:string, isXhtml:any) => {
//     const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
//     return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
// }

  return (
    <>
      <h1 className="title">
        <FormattedMessage {...translations.bugreport} />
      </h1>
      <div className="box">

        <p className="subtitle is-5">
          <FormattedMessage {...translations.description} />
        </p>

      <div className="control">
        <textarea rows={parseInt("15")} style={{fontFamily: "Courier"}} disabled className="textarea is-info" id="bugreporttext" value= {prepareBugReport()} />{/* tslint:disable-line */}
      </div>
      <br />


            <p className="subtitle is-5"> <FormattedMessage {...translations.mask} /></p>


      <nav className="level">
        <div className="level-left">
          <div className="level-item">
            <div className="field is-grouped">
              <p className="control">
                <CopyToClipboard text={"[CODE]\n" + bugreport + "\n[/CODE]"}>
                {/* <CopyToClipboard text={"[CODE]\n" + nl2br(bugreport,true) + "\n[/CODE]"}> */}
                  <a className="button is-link" onClick={() => toast({message: props.intl.formatMessage(translations.copied) , type: "is-link", dismissible: "true", position: "top-right", opacity: "1", duration: "3500"})}> {/* tslint:disable-line */}
                    <span><FormattedMessage {...translations.copy} /></span>
                  </a>
                </CopyToClipboard>
              </p>
              <p className="control">
                <a
                  className="button is-primary"
                  onClick={() => {
                    openInNewTab("https://campaign-community.com/index.php?forums/generators.33/");  {/* tslint:disable-line */}
                  }}
                >
                  <span>
                    <FormattedMessage {...translations.button} />
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </nav>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.oidc.user.profile.name
  };
};

export default connect(
  mapStateToProps,
  {}
)(injectIntl(Bugreport));



// WEBPACK FOOTER //
// ./src/components/UI/Utilities/Bugreport/Bugreport.tsx